import { Stack } from '@mui/material';
import UserLoopSelector from './UserLoopSelector';
import UserLoopUpgradeMessage from './UserLoopUpgradeMessage';
import { UserLoopSelectorProps } from './types';

const UserLoopSelectorContainer = ({
  value,
  onChange,
}: UserLoopSelectorProps) => (
  <Stack>
    <UserLoopSelector value={value} onChange={onChange} />
    <UserLoopUpgradeMessage />
  </Stack>
);

export default UserLoopSelectorContainer;
